import { Component } from 'san';
import * as _ from 'lodash';

import {
    IOrganization,
    IUser,
    IWorkflowCopyInfo,
    IWorkflowCopyInfoOrganization,
    IWorkflowCopyInfoPerson
} from 'src/models';

import auditService from 'src/services/audit.service';
import checkOrgUsersService from 'src/services/checkOrgUsers.service';
import checkOrganizationService from 'src/services/checkOrganization.service';

export default class CopyInfo extends Component {
    constructor(options: any) {
        super(options);
    }

    static components = {
    }

    initData(): {
        isDirty: boolean;
        editEnable: boolean;    // {{}} init传入editEnable，则取editEnable，无值则取 !audit.actions.is_detail
        auditId: string;    // {{}}
        persons: IWorkflowCopyInfoPerson[];
        organizations: IWorkflowCopyInfoOrganization[];
        url: string;
    } {
        return {
            isDirty: false,
            editEnable: undefined,
            auditId: null,
            persons: [],
            organizations: [],
            url: null
        };
    }

    inited() {
        const auditId = this.data.get('auditId');
        this.initCopyInfo(auditId);
    }

    //#region owner调用
    getDataSync(): IWorkflowCopyInfo {
        return {
            items: this.data.get('persons'),
            org_items: this.data.get('organizations'),
            url: this.data.get('url')
        };
    }
    // 是否变更过
    getIsDirtySync(): boolean {
        return this.data.get('isDirty');
    }
    // 重置是否变更过
    resetIsDirtySync() {
        this.data.set('isDirty', false);
    }
    //#endregion

    initCopyInfo(auditId: string) {
        auditService.getAuditCopyInfo(auditId).then(copyInfo => {
            const workflowCopyInfo = copyInfo.workflow_copy_info;
            const persons = workflowCopyInfo && workflowCopyInfo.items || [];
            const organizations = workflowCopyInfo && workflowCopyInfo.org_items || [];
            const url = workflowCopyInfo && workflowCopyInfo.url;

            let dataKey = 'persons';
            const oldPersons = this.data.get(dataKey);
            this.data.splice(dataKey, [0, oldPersons.length, ...persons]);

            dataKey = 'organizations';
            const oldOrganizations = this.data.get(dataKey);
            this.data.splice(dataKey, [0, oldOrganizations.length, ...organizations]);

            dataKey = 'url';
            this.data.set(dataKey, url);

            dataKey = 'editEnable';
            const editEnable = this.data.get(dataKey);
            // init传入editEnable，则取editEnable，无值则取 !audit.actions.is_detail
            if (_.isUndefined(editEnable)) {
                this.data.set(dataKey, copyInfo.edit_enable);
            }
        });
    }

    toAddPersons() {
        checkOrgUsersService.show({
            isMultiple: true,
            callback: (users) => {
                this.addPersons(users);
            }
        });
    }
    addPersons(users: IUser[]) {
        let persons: IWorkflowCopyInfoPerson[] = [];
        _.forEach(users, user => {
            persons.push({
                user_id: user.user_id,
                name: user.name,
                avatar: user.avatar,
            });
        });
        const dataKey = 'persons';
        const oldPersons = this.data.get(dataKey);
        persons = _.concat(oldPersons, persons);
        persons = _.uniqBy(persons, 'user_id');
        this.data.splice(dataKey, [0, oldPersons.length, ...persons]);
        this.data.set('isDirty', true);
    }

    deletePerson(person: IWorkflowCopyInfoPerson) {
        if (!this.data.get('editEnable')) {
            return;
        }
        const dataKey = 'persons';
        const oldPersons = this.data.get(dataKey);
        const index = _.findIndex(oldPersons, { user_id: person.user_id });
        if (-1 === index) {
            return;
        }
        this.data.removeAt(dataKey, index);
        this.data.set('isDirty', true);
    }

    toAddOrganization() {
        checkOrganizationService.show({
            callback: (organization) => {
                this.addOrganization(organization);
            }
        });
    }
    addOrganization(organization: IOrganization) {
        const org: IWorkflowCopyInfoOrganization = {
            org_number: organization.org_number,
            org_name: organization.org_name
        };
        const dataKey = 'organizations';
        const oldOrganizations = this.data.get(dataKey);
        if (-1 !== _.findIndex(oldOrganizations, { org_number: org.org_number })) {
            return;
        }
        this.data.push(dataKey, org);
        this.data.set('isDirty', true);
    }

    deleteOrganization(organization: IWorkflowCopyInfoOrganization) {
        if (!this.data.get('editEnable')) {
            return;
        }
        const dataKey = 'organizations';
        const oldOrganizations = this.data.get(dataKey);
        const index = _.findIndex(oldOrganizations, { org_number: organization.org_number });
        if (-1 === index) {
            return;
        }
        this.data.removeAt(dataKey, index);
        this.data.set('isDirty', true);
    }

}